<template>
   <div class="card">
      <div class="card-body m-2">
         <div class="row p-2 align-items-center">

            <!-- Generate Button -->
            <div class="col-12 col-lg-auto d-flex mb-2 mb-lg-0 gap-2">
               <button type="button" class="fw-bold btn text-light btn-sm"
                  style="font-size: 14px; height: 40px; border-radius: 8px !important; padding: 0 1.5rem; white-space: nowrap; background: #00a0c1;"
                  @click="showGenerateModal = true">
                  <i class="fa-regular fa-gears me-1"></i> Generate API Key
               </button>
            </div>
         </div>

         <!-- Table -->
         <div class="row p-2">
            <table class="table align-middle mainTable">
               <thead class="align-middle">
                  <tr>
                     <th v-for="header in headers" :key="header.value">{{ header.text }}</th>
                  </tr>
               </thead>

               <tbody v-if="api_keys.length <= 0">
                  <tr>
                     <td colspan="5">No API keys generated yet.</td>
                  </tr>
               </tbody>

               <tbody v-else>
                  <tr v-for="(api_key, index) in api_keys" :key="index">
                     <td style="max-width: 200px; font-family: monospace; font-size: 12px;" :title="api_key.api_key">
                        {{ api_key.api_key }}
                        <input type="hidden" :id="'id_' + api_key.api_key" :value="api_key.api_key">
                     </td>
                     <td>
                        <button type="button" class="ms-action-btn ms-action-btn--edit"
                            title="Copy API Key"
                           @click="CopyAPIKey(api_key.api_key)"><i class="fa-solid fa-copy"></i></button>
                     </td>
                     <td>{{ formatDate(api_key.date_created) }}</td>
                     <td>
                        <span v-if="api_key.is_disabled == 0" class="status-pill status-enabled">
                           <i class="fa-solid fa-circle-check me-1"></i>Enabled
                        </span>
                        <span v-else class="status-pill status-disabled">
                           <i class="fa-solid fa-ban me-1"></i>Disabled
                        </span>
                     </td>
                     <td>
                        <div class="d-flex gap-2">
                           <button v-if="api_key.is_disabled == 0" type="button"
                              class="ms-action-btn ms-action-btn--warning" 
                              title="Disable API Key" @click="disableApiKey(api_key)">
                              <i class="fa-solid fa-ban"></i>
                           </button>
                           <button v-if="api_key.is_disabled == 1" type="button"
                              class="ms-action-btn ms-action-btn--success" 
                              title="Enable API Key" @click="enableApiKey(api_key)">
                              <i class="fa-solid fa-cloud-bolt"></i>
                           </button>
                           <button type="button" class="ms-action-btn ms-action-btn--delete"
                              
                              @click="deleteApiKey(api_key.id)"><i class="fa fa-xmark"></i></button>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div>

   <!-- Generate Modal -->
   <div class="modal-backdrop-custom" v-if="showGenerateModal" @click.self="showGenerateModal = false">
      <div class="modal-content-custom">
         <button @click="showGenerateModal = false" class="close-button-custom">&times;</button>
         <h5 class="modal-title-custom">
            <i class="fa-regular fa-gears me-2" style="color: #00a0c1;"></i>
            Generate Account API Key
         </h5>
         <hr>
         <div class="modal-body-custom">
            <p>Are you sure you want to generate an Account API Key?</p>
         </div>
         <div class="modal-footer-custom">
            <button type="button" class="btn btn-sm btn-modal-cancel" @click="showGenerateModal = false">Cancel</button>
            <button type="button" class="btn btn-sm text-light" style="background: #00a0c1; border-radius: 8px;"
               @click="generateAccountAPIKey(); showGenerateModal = false;">
               <i class="fa-regular fa-gears me-1"></i> Generate
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import moment from 'moment'
export default {

   components: {},

   data() {
      return {
         showGenerateModal: false,
         headers: [
            { text: "API Key", value: "api_key" },
            { text: "", value: "" },
            { text: "Date Generated", value: "date_created" },
            { text: "Status", value: "status" },
            { text: "Action", value: "action" },
         ],
         api_keys: [],
      };
   },

   mounted() { this.init(); },

   methods: {
      init() { this.getAccountApiKeys() },

      formatDate(date) { return moment(date).format("DD-MMM-YYYY @ HH:mm:ss") },

      async getAccountApiKeys() {
         await this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-api-keys")
            .then((response) => { this.api_keys = response.data.api_keys })
            .catch((error) => {
               console.log(error)
               this.$toast.error(error.response.data.message)
            })
      },

      CopyAPIKey(api_key) {
         let testingCodeToCopy = document.querySelector(`#id_${api_key}`)
         testingCodeToCopy.setAttribute('type', 'text')
         testingCodeToCopy.select()
         document.execCommand('copy');
         testingCodeToCopy.setAttribute('type', 'hidden')
         window.getSelection().removeAllRanges()
         this.$toast.success(`${api_key} copied to clipboard.`)
      },

      async generateAccountAPIKey() {
         try {
            const payload = {}
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/generate-account-api-key", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getAccountApiKeys()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(error.response.data.message)
         }
      },

      async disableApiKey(api_key) {
         try {
            const payload = { is_disabled: 1, id: api_key.id }
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/change-account-api-key-activeness", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getAccountApiKeys()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(error.response.data.message)
         }
      },

      async enableApiKey(api_key) {
         try {
            const payload = { is_disabled: 0, id: api_key.id }
            const resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/change-account-api-key-activeness", payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getAccountApiKeys()
            }
         } catch (error) {
            this.$toast.error(error.response.data.message)
         }
      },

      async deleteApiKey(id) {
         try {
            const payload = { id: id }
            const resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-account-api-key/" + id, payload)
            if (resp.data.success != null && resp.data.success == false) {
               this.$toast.error(resp.data.message)
            } else {
               this.$toast.success(resp.data.message); this.getAccountApiKeys()
            }
         } catch (error) {
            console.log(error)
            this.$toast.error(error.response.data.message)
         }
      },
   }
}
</script>

<style scoped>
.card { border: none; }

.btn-outline-info { color: #00A0C1; border-color: #00A0C1; }
.btn-outline-info:hover { color: #fff; background-color: #00A0C1; border-color: #00A0C1; }

/* Status pill */
.status-pill {
   padding: 4px 10px;
   border-radius: 6px;
   font-size: 11px;
   font-weight: 600;
   display: inline-flex;
   align-items: center;
   gap: 2px;
   white-space: nowrap;
}
.status-enabled { background: #e6f9ee; color: #00873c; }
.status-disabled { background: #fde8ea; color: #c62828; }

/* Modal */
.modal-backdrop-custom {
   position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
   background-color: rgba(0,0,0,0.5); display: flex;
   justify-content: center; align-items: center; z-index: 1050;
}
.modal-content-custom {
   position: relative; background: #fff; padding: 2rem;
   border-radius: 14px; width: 100%; max-width: 460px;
   box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}
.modal-title-custom { font-weight: 700; font-size: 1.1rem; color: #435666; margin-bottom: 0; }
.modal-content-custom hr { margin: 0.75rem 0 1rem; border-color: #e9ecef; }
.close-button-custom {
   position: absolute; top: 0.75rem; right: 1rem;
   font-size: 1.8rem; font-weight: bold; line-height: 1;
   color: #adb5bd; background: none; border: none; cursor: pointer;
}
.close-button-custom:hover { color: #435666; }
.modal-body-custom { font-size: 14px; color: #435666; }
.modal-footer-custom { margin-top: 1rem; display: flex; justify-content: flex-end; gap: 8px; }
.btn-modal-cancel { background: #e9ecef; border: none; border-radius: 8px; color: #435666; }
</style>